import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";
import { VaultCard } from "../components/VaultCard";
import { RoyalListForm } from "../components/RoyalListForm";

export default function Vault() {
  const [items, setItems] = useState(null);

  useSEO("The Royal Vault", "Queen Denae's private archive of unreleased music — rare recordings, demos and compositions preserved outside the official release catalog.");

  useEffect(() => {
    api.get("/vault").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="royal-vault-archive" className="pt-32 sm:pt-40 pb-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <h1 className="font-serif text-5xl sm:text-7xl tracking-tight text-cream" data-testid="vault-heading">
            THE ROYAL<br /><span className="italic text-goldglow">VAULT</span>
          </h1>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 max-w-2xl">
          <p className="text-lg text-cream/85 leading-relaxed">
            Step inside Queen Denae's private archive of unreleased music.
          </p>
          <p className="mt-4 text-sand leading-relaxed">
            The Royal Vault preserves original recordings, demos, compositions and creative works I've chosen to keep outside my official release catalog — pieces of the journey, kept on purpose.
          </p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-1 font-serif italic text-cream/75">
            <span>Some are rare.</span>
            <span>Some are personal.</span>
            <span className="text-goldglow">All of them are part of the story.</span>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {(items || []).map((entry, i) => (
            <VaultCard key={entry.id} entry={entry} index={i} />
          ))}
        </div>
        {items && items.length === 0 && (
          <p className="mt-16 text-center text-sand font-serif italic text-xl">The Vault doors are being prepared. Check back soon.</p>
        )}

        <Reveal className="mt-24 border border-gold/20 bg-gallery p-8 sm:p-12">
          <div className="max-w-xl mx-auto text-center">
            <p className="font-serif text-3xl text-cream tracking-tight">Never miss a drop.</p>
            <p className="mt-3 text-sm text-sand">Vault releases land here first — the Royal List hears about them before anyone else.</p>
            <div className="mt-8 text-left">
              <RoyalListForm source="royal-vault" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
